import React, { useState, useEffect } from 'react'
import PageLayout from './common/layout/PageLayout'
import MarkdownRenderer from './common/MarkdownRenderer'
import './LegalDocument.css'

function TermsOfService() {
  const [content, setContent] = useState('')

  useEffect(() => {
    fetch('/legal/terms_of_service.md')
      .then((response) => response.text())
      .then((text) => setContent(text))
      .catch((error) => console.error('Error loading Terms of Service:', error))
  }, [])

  return (
    <PageLayout
      title="Terms of Service"
      noCard={true}
      heroContent={<></>}
      showHeader={false}
    >
      <div className="legal-page-wrapper">
        <div className="legal-document">
          {content ? (
            <MarkdownRenderer content={content} />
          ) : (
            <p>Loading Terms of Service...</p>
          )}
        </div>
      </div>
    </PageLayout>
  )
}

export default TermsOfService
